module.exports = __webpack_public_path__ + "img/20191218154806369.b51fbc6a.jpg";